export const FACTOR_WEIGHT_MIN = 0;
export const FACTOR_WEIGHT_MAX = 100;
export const FACTOR_WEIGHT_STEP = 1;

export const FactorGroup = {
  COST: 'COST',
  CAPACITY: 'CAPACITY',
  RISK: 'RISK',
};

export const FACTOR_GROUP_LABELS = {
  [FactorGroup.COST]: 'Cost Factors',
  [FactorGroup.CAPACITY]: 'Capacity Factors',
  [FactorGroup.RISK]: 'Risk Factors',
};

export const FACTOR_GROUP_SHORT_LABELS = {
  [FactorGroup.COST]: 'Cost',
  [FactorGroup.CAPACITY]: 'Cap',
  [FactorGroup.RISK]: 'Risk',
};

export const FACTOR_GROUP_PALETTE_KEYS = {
  [FactorGroup.COST]: 'primary',
  [FactorGroup.CAPACITY]: 'success',
  [FactorGroup.RISK]: 'warning',
};

export const FACTOR_DEFINITIONS = [
  {
    key: 'costWeight',
    label: 'All-in Borrowing Cost',
    description:
      'Considers total borrowing cost including interest rate, fees, and other charges across all warehouse lines.',
    group: FactorGroup.COST,
  },
  {
    key: 'advanceRateWeight',
    label: 'Advance Rate / Cash Outlay',
    description:
      'Evaluates the advance rate offered by each line to minimize out-of-pocket cash required per loan.',
    group: FactorGroup.COST,
  },
  {
    key: 'nonUseFeeWeight',
    label: 'Non-Use Fee Avoidance',
    description:
      'Prioritizes lines that would incur non-use fees if not utilized, helping avoid unnecessary charges.',
    group: FactorGroup.COST,
  },
  {
    key: 'utilizationBalanceWeight',
    label: 'Utilization Balance',
    description:
      'Distributes loans across lines to maintain balanced utilization and avoid over-concentrating on a single line.',
    group: FactorGroup.CAPACITY,
  },
  {
    key: 'subLimitHeadroomWeight',
    label: 'Sub-Limit Headroom',
    description:
      'Considers remaining capacity within product-specific sub-limits to ensure loans fit within constraints.',
    group: FactorGroup.CAPACITY,
  },
  {
    key: 'concentrationRiskWeight',
    label: 'Concentration Risk',
    description:
      'Reduces exposure to any single warehouse bank by spreading allocations across multiple lines.',
    group: FactorGroup.RISK,
  },
  {
    key: 'expirationProximityWeight',
    label: 'Expiration Proximity',
    description:
      'Deprioritizes lines approaching their expiration date to reduce risk of curtailment before loan sale.',
    group: FactorGroup.RISK,
  },
  {
    key: 'curtailmentRiskWeight',
    label: 'Curtailment Risk',
    description:
      'Evaluates the risk of early repayment demands based on line terms and aging of existing allocations.',
    group: FactorGroup.RISK,
  },
];

export const WEIGHT_FIELD_KEYS = FACTOR_DEFINITIONS.map(({ key }) => key);

export const DEFAULT_FACTOR_WEIGHTS = FACTOR_DEFINITIONS.reduce(
  (acc, { key }) => ({ ...acc, [key]: 50 }),
  {},
);

export const PERCENTAGE_MULTIPLIER = 100;

export const PAGE_TITLE = 'Optimization Strategies';
